export interface objectTypes {
    isError: boolean,
    message: string,
    isDisable: boolean,
    value: any,
    id?: any,
    verifiedDetails?: any
    code?: number,
    reportId: string,
    serviceId: string,
}

export interface formStateType {
    [key: string]: objectTypes
}

export interface formDataType {
    [key: string]: any;
}

export const initObject={
        adverseEffect: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            reportId: '',
            serviceId: '',
        },
        deathDate: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
            reportId: '',
            serviceId: '',
        },
        deathByAEFI: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            reportId: '',
            serviceId: '',
        },
        reportedDate: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            reportId: '',
            serviceId: '',
        }
    }